import { Pipe, PipeTransform } from '@angular/core';
import { ScreeningResultCode } from '../../applications/models/applications.model';

@Pipe({
  standalone: false,
  name: 'screeningResult'
})
export class ScreeningResultPipe implements PipeTransform {
  private types: { [key: string]: string } = {};

  constructor() {
    this.types[ScreeningResultCode.passed] = 'Alternative Approved';
    this.types[ScreeningResultCode.failed] = 'Alternative Rejected';
    this.types[ScreeningResultCode.noResult] = 'N/A';
  }

  transform(value: ScreeningResultCode): string {
    return this.types[value] ?? 'Unknown';
  }
}
